// package imports
import React from 'react';
import { IconType } from 'react-icons';

// CSS imports
import './TransparentButton.css';

type Props = {
  className?: string;
  label?: string;
  ReactIcon?: IconType;
  imgIcon?: string;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
};

const TransparentButton: React.FC<Props> = ({
  className,
  label,
  ReactIcon,
  imgIcon,
  onClick,
}: Props) => {
  return (
    <button
      className={`TransparentButton ${className ? className : ''}`}
      onClick={onClick}
    >
      {ReactIcon ? (
        <ReactIcon className={label ? 'btn-icon' : 'only-btn-icon'} />
      ) : imgIcon ? (
        <img
          src={imgIcon}
          alt={label}
          className={label ? 'btn-icon' : 'only-btn-icon'}
        />
      ) : null}
      <b>{label ? label : null}</b>
    </button>
  );
};

export default TransparentButton;
